import { RESTError } from "../core/RESTError";

/**
 * An error that occurs while logging in a user, which was not found.
 */
export class UserNotFoundError extends RESTError {}
